import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[locale]/pricing/page.tsx");
